export default {
  SETTINGS: '/settings',
  FEATURES: '/plugins',
  FINAL: '/final',
};
